import React, { useCallback, useState } from 'react'

import icons from '../assets/icons'

type Props = {
  visible: boolean

  srcImage: string

  onPressRow: () => void

  data: Array<any>

  title: string

  onPickItem: (item: any) => void
}

type ItemProps = {
  item: any

  onPickItem: (name: string) => void
}

const Item: React.FC<ItemProps> = ({ item, onPickItem }: ItemProps) => {
  const handleOnClick = useCallback(() => {
    onPickItem(item)
  }, [item, onPickItem])

  return (
    <div
      className='select--selectItem'
      onClick={handleOnClick}
      key={item.name}
    >
      <p className='text text--size13 text--center'>
        {item.name}
      </p>
    </div>
  )
}

const SelectComponent: React.FC<Props> = ({
  visible,
  srcImage,
  onPressRow,
  title,
  data,
  onPickItem,
}: Props) => {
  return (
    <div className={`select--item ${visible ? 'select--item--opened' : 'select--item--closed'}`}>
      <div className='select--firstrow' onClick={onPressRow}>
        <img src={srcImage} alt='ship-picker' style={{ width: 32, height: 32, marginRight: 8 }} />
        <p className='text text--flex'>{title}</p>
        <img
          src={icons.chevron}
          alt='chevron'
          className={`select--chevron ${visible && 'select--chevron--opened'}`}
        />
      </div>
      <div className={`${!visible && 'hide'}`}>
        {data
          .sort((a, b) => {
            if (a.name < b.name) {
              return -1
            }
            if (a.name > b.name) {
              return 1
            }
            return 0
          })
          .map((value) => {
            return <Item item={value} onPickItem={onPickItem} key={value.name} />
          })}
      </div>
    </div>
  )
}

export default SelectComponent
